import {createRoot} from 'react-dom/client'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import "react-responsive-modal/styles.css";
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import axios from 'axios'
import ReactGA from "react-ga4";


if(process.env.REACT_APP_GOOGLE_ANALYTICS_CODE && process.env.REACT_APP_GOOGLE_ANALYTICS_CODE !== '' ) {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_CODE)
}

setupAxios(axios)
const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}
